import { useState } from "react";
import { Container } from "../components/Container";
import { Link } from "react-router-dom";

const infos = [
    {
        no: 1,
        title: "활성산소를 알아보아요.",
        description:
            "먼저, 활성산소에 대해 세간 사람들이 주목 한 계기를 알아봐야 합니다.혹시 프렌치 패러독스(French Paradox, 프랑스인의 역설)라는 말을 들어보셨나요? 동물성 지방을 포함해 고지방 식이를 하고도 미국과 같이 고지방 식이를 즐겨 하는 다른 나라의 국민들에 비해 심장 질환에 의한 사망률이 현저히 낮은 것을 말한 것입니다. ",
        contents:
            "먼저, 활성산소에 대해 세간 사람들이 주목 한 계기를 알아봐야 합니다. 혹시 프렌치 패러독스(French Paradox, 프랑스인의 역설)라는 말을 들어보셨나요? 동물성 지방을 포함해 고지방 식이를 하고도 미국과 같이 고지방 식이를 즐겨 하는 다른 나라의 국민들에 비해 심장 질환에 의한 사망률이 현저히 낮은 것을 말한 것입니다. 이에 많은 학자들은 프랑스인들이 평소 적포도주에 다량 포함되어 있는 폴리페놀(Polyphenol)이라는 체내 활성산소(Radical Oxygen Species)를 억제해주는 항산화 물질에 주목했습니다. 현대의학은 이미 노화와 각종 성인병의 주요한 기저 원인으로 활성산소로 보고, 이에 항산화 물질을 개발하는데 주력하고 있습니다. 또한 한국인들도 이러한 사실에 대해 잘 알고 있어 항산화 관련 영양제는 매년 높은 판매량을 보이고 있습니다. (미국 영양제 전문 쇼핑몰에서 매년 3위 안에 듦) 우리가 섭취한 음식물은 호흡을 통해 체내로 들어온 산소에 의해 산화되면서 세포의 생명현상의 유지에 필요한 각종 물질과 에너지를 만들어냅니다. 이때 우리 몸에서 산소를 사용하고 남는 부산물이 생겨나는데 이것을 활성산소라고 합니다. 이러한 부산물이 우리 몸 속에서 적당한 균형을 맞춰 존재한다면, 각종 세균과 바이러스로부터 건강을 지킬 수 있습니다. 하지만 활성산소는 매우 불안정하고 반응성(활동성)이 커서 세포를 구성하는 세포막 유전정보를 가지고 있는 DNA 및 각종 단백질들과 결합하고, 이들을 변화시켜 세포의 생존을 위협합니다. 따라서 활성산소가 과다 생성되거나, 체내에서 제거되지 않아 쌓이게 되면 오히려 우리의 면역력이 떨어지고, 노화를 촉진시키며 더 나아가 여러 질병과 암과 같은 난치병의 발생률을 높이기도 합니다.",
    },
    {
        no: 2,
        title: "활성산소와 노화는 연관이 깊다는 거 알고 계셨나요?",
        description:
            "노화 이론의 핵심은 바로 “활성산소론(活性酸素論)”입니다. 활성산소론은 우리가 생존을 위해 호흡을 통해 우리 몸으로 들어오는 산소와 에너지 생산 및 대사를 위해 섭취하는 음식이 노화의 원인이라고 주장하는 이론입니다.",
        contents: "",
    },
    {
        no: 3,
        title: "활성산소와 어떤 질병에 영향을 주나요?",
        description:
            "활성산소는 노화뿐만 아니라 우리의 건강에도 깊은 연관이 있습니다. 우리 몸 내부에서 항산화 반응을 지속할 수 없게 되면, 산화적 스트레스가 지속되고 체내에 증가된 활성산소가 신체 장기를 공격해 구조와 기능에 손상을 일으킵니다. 이에 질병 발생의 원인이 과도한 활성산소에 의한 산화적 스트레스와 관련되어 있음이 알려졌습니다.",
        contents: "",
    },
    {
        no: 4,
        title: "그럼 활성산소와 지방산 산화는 무슨 관계인가요?",
        description:
            "우리 몸 속에 활성산소가 증가하게 되면 세포의 정상적인 생리현상이 방해를 받거나 세포의    기능이 손상을 받는 상태에 이르게 되는데 이것을 “산화성 스트레스(oxidative stress)”라고 합니다. 산화성 스트레스 상태에서는 우리 몸의 세포막을 구성하는 성분인 지방산이 활성산소에 의해 공격을 받아 과산화지질을 형성하고 이들은 정상적으로 분해되지 못하고 체내에 축적됩니다. ",
        contents: "",
    },
    {
        no: 5,
        title: "활성산소는 어떻게 제거하나요?",
        description: "운동하기 적당한 운동은 항산화에 도움을 줍니다.",
        contents: "",
    },
    {
        no: 6,
        title: "활성산소는 어떻게 제거하나요?",
        description:
            "대표적으로 브로콜리가 있습니다. 브로콜리는 특히 비타민 C가 레몬의 2배가 될 정도로 매우 풍부하며, 브로콜리 줄기에는 비타민 A가 많아 유해산소를 억제하고 이를 제거하는데   많은 도움이 됩니다.",
        contents: "",
    },
];

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

export function Oxygen() {
    let [expand, setExpand] = useState(false);
    let [selectedTitle, setSelectedTitle] = useState();

    return (
        <section id="oxygen" aria-labelledby="oxygen-title" className="border-t border-gray-200 py-20 sm:py-16">
            <Container>
                <div className="mx-auto max-w-2xl text-center mb-16">
                    <h2 className="text-3xl font-medium tracking-tight text-gray-900 mt-9">활성산소에 대해 알아보아요</h2>
                </div>
                <div className="divide-y divide-gray-200 overflow-hidden rounded-lg bg-gray-200 shadow sm:grid sm:grid-cols-2 sm:gap-px sm:divide-y-0">
                    {!expand &&
                        infos.map((info, infoIdx) => (
                            <div
                                key={info.title}
                                className={classNames(
                                    infoIdx === 0 ? "rounded-tl-lg rounded-tr-lg sm:rounded-tr-none" : "",
                                    infoIdx === 1 ? "sm:rounded-tr-lg" : "",
                                    infoIdx === infos.length - 2 ? "sm:rounded-bl-lg" : "",
                                    infoIdx === infos.length - 1 ? "rounded-bl-lg rounded-br-lg sm:rounded-bl-none" : "",
                                    "group relative bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-500"
                                )}
                            >
                                <div className="mt-8">
                                    <h3 className="text-base font-semibold leading-6 text-gray-900">
                                        <span
                                            className="focus:outline-none"
                                            onClick={() => {
                                                setExpand(!expand);
                                                setSelectedTitle(info.contents);
                                            }}
                                        >
                                            <span className="absolute inset-0" aria-hidden="true" />
                                            {info.title}
                                        </span>
                                    </h3>
                                    <p className="mt-2 text-sm text-gray-500">{info.description}</p>
                                </div>
                                <Link to={`/article/${info.no}`} key={info.no}>
                                    <span className="absolute inset-0" />
                                </Link>
                                {/* <span
                                    className="pointer-events-none absolute right-6 top-6 text-gray-300 group-hover:text-gray-500"
                                    aria-hidden="true"
                                >
                                    <svg viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                                        <path d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
                                    </svg>
                                </span> */}
                            </div>
                        ))}
                </div>
                {expand && <div className="relative flex bg-white rounded-bl-lg rounded-lg shadow p-6 mx-auto ">{selectedTitle}</div>}
            </Container>
        </section>
    );
}
